<template>
    <div class="w-full bg-eblack-100/70 rounded-lg overflow-y-auto">
        <div 
        class="w-full p-1" 
        v-if="services.length > 0">
            <div 
            class="w-full border border-eorange-100 bg-white rounded-lg flex flex-col px-2 py-1 gap-4" 
            v-for="service in services" 
            :key="service.id">
                <div class="flex justify-between items-center px-2 pt-1">
                    <span  class="text-md text-eblack-900">{{ service.name }}</span>
                    <span class="text-sm py-0.5 px-4 rounded-full border flex gap-x-2 items-center">
                        <IconClock class="w-4 h-4" stroke={2} />{{ $t("provider.auto.1_hora") }}</span>
                </div>
                <p class="text-sm text-eblack-600">{{ service.description }}</p>
            </div>
            
        </div>
        <div class="w-full p-1" v-else>
            <div 
            class="w-full border border-eorange-100 bg-white rounded-lg flex flex-col px-2 py-1 gap-4">
                <p class="text-sm text-eblack-600">{{ $t("provider.auto.no_se_han_asociados_servicios_a_este_proveedor") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { IconClock } from '@tabler/icons-vue';
    export default {
        props:['provider'],
        name:"ServiceTab",
        data(){
            return {
                providerTemp:[],
                services:[]
            }
        },
        watch:{
        'provider':{
            handler(value){
                if(value){
                    if(value){
                        this.services= value.services
                    }
                }

            },
            immediate:true
        }
        },
        components:{
            IconClock
        },
        methods:{

        },
        mounted(){
        }
    }
</script>

<style lang="scss" scoped>

</style>